import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ModalResult, ModalAnswer } from '../../../shared/models/shared.model';
import { SelectableDealer, Dealer } from "../../model/distributor.model";
import { AdaService } from '../../../shared/services/ada.service';

@Component({
  selector: 'app-select-dealer',
  templateUrl: './select-dealer.component.html',
  styleUrls: ['./select-dealer.component.scss']
})
export class SelectDealerComponent implements OnInit {

  @Input() visible = false;
  @Input() title = '';
  // @Input() availableDealers: Array<SelectableDealer> = [];
  @Input() dealers: Array<Dealer> = [];

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onModalClose: EventEmitter<ModalResult> = new EventEmitter<ModalResult>();
  completionPopupData = {
    title: '',
    visible: false,
    message: ''
  };

  selectedRows: Dealer[] = [];;

  constructor(private _adaService: AdaService) { }

  ngOnInit() {
  }

  whenPopupHidden(e) {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  confirmSelection() {
    this.onModalClose.emit({answer: ModalAnswer.OK, data: this.selectedRows});
  }

  onCancel() {
    this.onModalClose.emit({answer: ModalAnswer.CANCEL, data: 'data'});
  }

  get adaService() {
    return this._adaService;
  }
}



// WEBPACK FOOTER //
// ./src/app/distributor/components/select-dealer/select-dealer.component.ts